export const VIMEO_VIDEO_PROVIDER = "vimeo"
export const YOUTUBE_VIDEO_PROVIDER = "youtube"

export type VideoProvider = typeof VIMEO_VIDEO_PROVIDER | typeof YOUTUBE_VIDEO_PROVIDER

export function isYouTubeVideoProvider(
    provider?: string | null
): provider is typeof YOUTUBE_VIDEO_PROVIDER {
    return provider === YOUTUBE_VIDEO_PROVIDER
}
